// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import ForgotPassword from '../Authentication/ForgotPassword';
function Home() {
  return (
    <div>
      <ForgotPassword/>
    </div>
  );
}

export default Home;